let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iPSld")).then(() => parcelRequire('jOpec'));